import styled from 'styled-components';
import { ColorAddiCompFiveBase, ColorAddiFontHint, ColorAddiGrayLighten3 } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilySecondaryName } from '@addi/foundation/dist/web/fonts';
export const SearchContainer = styled.div `
  width: ${({ width }) => width || '290px'};
  height: 44px;
  position: relative;
`;
export const Search = styled.input `
  width: 100%;
  height: 100%;
  border: 1px solid ${ColorAddiGrayLighten3};
  font-family: ${FontAddiFamilySecondaryName};
  padding: 0px 16px;
  font-size: 16px;
  color: #333;
  outline: none;
  background-color: #fff;
  box-shadow: 0px 4px 12px rgba(86, 90, 97, 0.12);
  border-radius: 4px;
  &::placeholder {
    color: ${ColorAddiFontHint};
  }
  &:focus {
    border: 2px solid  ${ColorAddiCompFiveBase};
  }
`;
//# sourceMappingURL=SearchInput.styled.js.map